import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 15.25H4.5a3.75 3.75 0 0 1 0-7.5h2.25Zm0 0a22.3 22.3 0 0 1 12.366 3.744l1.134.756V3.25l-1.134.756A22.3 22.3 0 0 1 6.75 7.75ZM23.25 10v3m-16.5 2.25A7.24 7.24 0 0 0 9 20.5"
    }, null, -1)
  ]));
}
const interfaceShareMegaphoneBullhorn = { render };
export {
  interfaceShareMegaphoneBullhorn as default,
  render
};
//# sourceMappingURL=interface-share-megaphone-bullhorn.svg.js.map
